<header class="navbar ">
  <div class="container-fluid">
    <div class="header-left">
      <a id="capLogo" class="navbar-brand "><img src="./assets/images/logos/erx-logo.svg" alt="erx logo"
          style="max-width: 50px; height: auto;"></a>
    </div>
    <div class="user  top-dropdown">
      <div id="userClick" class="down-click-btn" (click)="showlogout()">
        <div class="user--icon">
          <img src="assets/images/icons/user.svg" alt="User Image">
          <div class="dropdown-arrow"></div>
        </div>
      </div>
      <div class="user-drop-down" [ngClass]="{'active':userDropdown}">

        <div class="d-flex user-head">
          <div class="user-icon">
          </div>
          <div class="user-details">
            <p>{{userName}}</p>
            <span>{{userRole}}</span>
          </div>
        </div>
        <div class="user-logout">
          <ul>
            <li>
              <a class="logout" (click)="logout()"> Logout</a>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</header>
